import TableLayout from "../../table/table-layout";
// import { allUserData } from "@/data/all-users";
import { useUsers } from "../../../../hooks/use-user";
import AllUsersTable from "./all-user-table";
import { User } from "packages/app/src/types";

const pageHeader = {
  title: "All Users",
  breadcrumb: [],
};

interface AllUsersTableProps {
  users: User[];
  isLoading: boolean;
  error: Error | null;
}

export default function AllUsersDashboard({
  users,
  isLoading,
  error,
}: AllUsersTableProps) {
  return (
    <div className="@container">
      <TableLayout
        title={pageHeader.title}
        breadcrumb={pageHeader.breadcrumb}
        data={users}
        fileName="all_users_data"
        header="ID,FirstName,LastName,Email,KYC,Verified,CreatedAt"
      >
        <AllUsersTable users={users} isLoading={isLoading} error={error} />
      </TableLayout>
    </div>
  );
}
